import { globalLogger } from '../../../qaamgo/helper/global-logger';

if (global.MODULE_LOADED_PROTECT_COMPRESS) {
    globalLogger.log('double import');
} else {
    global.MODULE_LOADED_PROTECT_COMPRESS = true;

    import(
        /* webpackMode: "eager" */
        '../qg-feature'
    ).then(function () {
        var pwdUserSuccess = false;
        let togglePasswordProtection = function () {
            let password = document.getElementById('compress_new_password');
            let repeatPassword = document.getElementById('compress_confirm_password');

            let currentTarget = document.querySelector('input[name=password_protection]');
            
            if (!currentTarget.checked) {
                document.querySelector('div.password_protection').classList.add('d-none');
                password.disabled = true;
                password.readonly = true;
                repeatPassword.disabled = true;
                password.value='';
                repeatPassword.value='';
            } else {
                document.querySelector('div.password_protection').classList.remove('d-none');
                password.disabled = false;
                password.removeAttribute('readonly')
                repeatPassword.disabled = false;
            }
        }

        document.addEventListener('DOMContentLoaded', function (){
            togglePasswordProtection()
            document.getElementById('password_protection').addEventListener('change', togglePasswordProtection);
        });

        $(document).on('click', '.submit-btn', function (event) {

            if (document.getElementById('password_protection').checked === false) {
                qgFeaturePage.defaultSubmit();
                return;
            }

            if (validateProtectZipForm()) {
                qgFeaturePage.defaultSubmit();
            }
        });

        function validateProtectZipForm() {
            $('.form-group').each(function () {
                $(this).removeClass('has-error');
            });

            var _log = $.noop;

            if (typeof ocErrLog === 'object' && ocErrLog.hasOwnProperty('log') && typeof ocErrLog.log === 'function') {
                _log = ocErrLog.log;
            }

            return userPasswordCheck();
        }

        function userPasswordCheck() {
            $('.compress_new_passwordErr').addClass('hidden');
            $('.compress_confirm_passwordErr').addClass('hidden');
            
            let password = $('#compress_new_password').val();
            let repeatPassword = $('#compress_confirm_password').val();

            // allow only printable characters from latin-1
            let regex = /^[\u0021-\u007e|\u00a1-\u00ff]+$/;
            
            if (password == '' && repeatPassword == '') {
                $('.compress_new_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Enter open password'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#compress_new_passwordErr').css('border-color', '#dd4b39');
                
                $('.compress_confirm_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Re-enter open password'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#compress_confirm_passwordErr').css('border-color', '#dd4b39');

                return false;
            } else if (password == '') {
                $('.compress_new_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Enter open password'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#compress_new_passwordErr').css('border-color', '#dd4b39');

                $('.compress_confirm_passwordErr').addClass('hidden');
                return false;
            } else if (repeatPassword == '') {
                $('.compress_new_passwordErr').addClass('hidden');

                $('.compress_confirm_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Re-enter open password'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#compress_confirm_passwordErr').css('border-color', '#dd4b39');

                return false;
            } else if (password.length > 32) {
                $('.compress_confirm_passwordErr').addClass('hidden');

                $('.compress_new_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Please enter open password with up to 32 characters'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#compress_new_passwordErr').css('border-color', '#dd4b39');

                return false;
            } else if (repeatPassword.length > 32) {
                $('.compress_new_passwordErr').addClass('hidden');

                $('.compress_confirm_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Please repeat open password with up to 32 characters'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#compress_confirm_passwordErr').css('border-color', '#dd4b39');

                return false;
            } else if (password != '' && repeatPassword != '' && password !== repeatPassword) {
                $('.compress_new_passwordErr').addClass('hidden');

                $('.compress_confirm_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Passwords don\'t match'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#compress_confirm_passwordErr').css('border-color', '#dd4b39');

                return false;
            } else if (!regex.test(password) == true) {
                $('.compress_new_passwordErr')
                    .removeClass('hidden')
                    .html(
                        Translator.trans(
                            'Invalid password. Only uppercase and lowercase characters, numbers, hyphens and underscores allowed.'
                        )
                    )
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#compress_new_passwordErr').css('border-color', '#dd4b39');

                $('.compress_confirm_passwordErr').addClass('hidden');

                return false;
            } else {
                pwdUserSuccess = true;
                return true;
            }
        }
    });
}
